import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { loginGuard } from './core/guards/login.guard';
import { roleGuard } from './core/guards/role.guard';
import { UserRole } from './core/models/user.model';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    loadComponent: () => import('./layout').then((m) => m.DefaultLayoutComponent),
    canActivate: [authGuard],
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/routes').then((m) => m.routes)
      },
      {
        path: 'projects',
        loadChildren: () => import('./views/projects/routes').then((m) => m.routes),
        canActivate: [roleGuard],
        data: { roles: [UserRole.CONSULTANT, UserRole.SUPER_ADMIN, UserRole.CONTRACTOR] }
      },
      {
        path: 'marketplace',
        loadChildren: () => import('./views/marketplace/routes').then((m) => m.routes),
        canActivate: [roleGuard],
        data: { roles: [UserRole.CONSULTANT, UserRole.SUPER_ADMIN] }
      },
      {
        path: 'client-portal',
        loadChildren: () => import('./views/client-portal/routes').then((m) => m.routes),
        canActivate: [roleGuard],
        data: { roles: [UserRole.CLIENT] }
      },
      {
        path: 'contractor',
        loadChildren: () => import('./views/contractor/routes').then((m) => m.routes),
        canActivate: [roleGuard],
        data: { roles: [UserRole.CONTRACTOR] }
      },
      {
        path: 'users',
        loadChildren: () => import('./views/users/routes').then((m) => m.routes),
        canActivate: [roleGuard],
        data: { roles: [UserRole.SUPER_ADMIN] }
      },
      {
        path: 'pages',
        loadChildren: () => import('./views/pages/routes').then((m) => m.routes)
      },
      {
        path: 'clients',
        loadChildren: () => import('./views/clients/routes').then((m) => m.routes),
        canActivate: [roleGuard],
        data: { roles: [UserRole.SUPER_ADMIN, UserRole.CONSULTANT] }
      },
      {
        path: 'companies',
        loadChildren: () => import('./views/companies/routes').then((m) => m.routes),
        canActivate: [roleGuard],
        data: { roles: [UserRole.SUPER_ADMIN, UserRole.CONSULTANT] }
      }
    ]
  },
  {
    path: '404',
    loadComponent: () =>
      import('./views/pages/page404/page404.component').then((m) => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    loadComponent: () =>
      import('./views/pages/page500/page500.component').then((m) => m.Page500Component),
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./views/pages/login/login.component').then((m) => m.LoginComponent),
    canActivate: [loginGuard],
    data: {
      title: 'Login Page'
    }
  },
  { path: '**', redirectTo: 'dashboard' }
];
